import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Avatars, UIKits } from "../../../Constants/Constants";
import AvatarSizes from "./AvatarSizes";
import Grouping from "./Grouping";
import Ratio from "./Ratio";
import Shapes from "./Shapes";
import StatusIndicator from "./StatusIndicator";
import { Fragment } from "react/jsx-runtime";
import AvatarInitial from "./AvatarInitial";
import BadgeIndicator from "./BadgeIndicator";
import AnimatedAvatar from "./AnimatedAvatar";

const AvatarsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Avatars} parent={UIKits} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <AvatarSizes />
            <StatusIndicator />
            <Shapes />
            <Ratio />
            <Grouping />
            <BadgeIndicator />
            <AvatarInitial />
            <AnimatedAvatar />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default AvatarsContainer;
